module.exports = __webpack_public_path__ + "img/vertical_7_1_8023.12075ec2.png";